// ─── CMS API helpers ─────────────────────────────────────────────────────────
// Talks to the Django app_cms endpoints (see wqlive/app_cms/):
//
//   GET/POST                 /api/cms/pages/            admin list + create
//   GET/PUT/PATCH/DELETE      /api/cms/pages/<slug>/     admin retrieve/update/delete
//   GET                      /api/cms/public/           published index (public)
//   GET                      /api/cms/public/<slug>/    published page (public)
//
// Same JWT-in-localStorage / Bearer-header convention as projectsApi.js.
// ─────────────────────────────────────────────────────────────────────────────

import axios from 'axios'

const API_URL         = import.meta.env.VITE_API_URL          || 'https://wqlive.ezxdemo.com'
const API_BASE_PATH   = import.meta.env.VITE_API_BASE_PATH    || '/api'
const JWT_STORAGE_KEY = import.meta.env.VITE_JWT_STORAGE_KEY  || 'auth_token'

const authHeaders = () => {
  const token = (localStorage.getItem(JWT_STORAGE_KEY) || sessionStorage.getItem(JWT_STORAGE_KEY))
  return {
    'Content-Type': 'application/json',
    ...(token ? { Authorization: `Bearer ${token}` } : {}),
  }
}

const url = (p) => `${API_URL}${API_BASE_PATH}/cms${p}`

// ── Admin (auth required) ──
export async function listCmsPages() {
  const res = await axios.get(url('/pages/'), { headers: authHeaders() })
  // DRF may paginate; support both a bare array and { results: [...] }.
  return Array.isArray(res.data) ? res.data : (res.data?.results || [])
}

export async function getCmsPage(slug) {
  const res = await axios.get(url(`/pages/${encodeURIComponent(slug)}/`), { headers: authHeaders() })
  return res.data
}

export async function createCmsPage(payload) {
  const res = await axios.post(url('/pages/'), payload, { headers: authHeaders() })
  return res.data
}

export async function updateCmsPage(slug, payload) {
  const res = await axios.patch(url(`/pages/${encodeURIComponent(slug)}/`), payload, { headers: authHeaders() })
  return res.data
}

export async function deleteCmsPage(slug) {
  await axios.delete(url(`/pages/${encodeURIComponent(slug)}/`), { headers: authHeaders() })
}

// ── Public (no auth, published only) ──
export async function fetchPublicCmsPage(slug) {
  const res = await axios.get(url(`/public/${encodeURIComponent(slug)}/`))
  return res.data
}

export async function listPublicCmsPages() {
  const res = await axios.get(url('/public/'))
  return Array.isArray(res.data) ? res.data : []
}
